import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Button, Grid, Typography, withStyles } from '@material-ui/core';
import createStyles from '@material-ui/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { ComboAndStandardTest } from '../../ComboAndStandardTest';
import { contentManagementAction } from '../../../reducers/contentMangementData';
import { editTest } from '../helper';
import { AddTestDialogPopUp } from '../../coursePlan/addTestDialog';
import { withRouter } from 'react-router-dom';
import dateService from '../../../../common/services/dateService';
import contentService from '../../../../mylibrary/services/contentService';
import { getPhaseIndex } from '../../coursePlan/addTestDialog/AddScheduledTestOnGoals/helpers';
import { checkForDuplicateTests } from '../../coursePlan/addTestDialog/helpers/checkAddedTest';
import { showMsg } from '../../../../course/actions/loaderAlert';
import ToggleInput from '../../../../common/ToggleInput';
import CustomInfoIcon from '../../../../common/CustomInfoIcon';
import { HIDE_TEST_POPUP_INFO } from '../../../Constants/constants';

const dateStyle = {
  color: '#999',
  fontSize: '16px',
};
const bullets = {
  color: '#C4C4C4',
  padding: '0px 10px',
  // marginTop: '5px',
};

const styles = (theme: Theme) =>
  createStyles({
    testTitle: {
      fontSize: 20,
      // lineHeight: '27px',
      color: '#333',
      // verticalAlign: 'super',
      marginLeft: 5,
      '&> img': {
        width: 20,
      },
    },
    dateAndTime: {
      fontSize: 16,
      fontWeight: 400,
      color: '#666',
      // lineHeight: '18px',
      // marginTop: 10,
    },
    marginL10: {
      marginLeft: 10,
    },
    marginL13: {
      marginLeft: 13,
    },
    faded: {
      opacity: 0.4,
    },
    displayFlex: {
      display: 'flex',
      alignItems: 'center',
      '& span': {
        marginRight: '10px',
      },
    },
  });
interface TestComponentProps {
  test?: any;
  packageData?: any;
  match?: any;
  isEmpty?: boolean;
  isConflict?: boolean;
  phase: any; // If week's test, we have week's object, otherwise phase's object
  phaseIndex: number;
  fromCombo?: boolean;
  treeData: any;
  setTreeData: Function;
  updateMilestoneTest: Function;
  updateMainTest: Function;
  deleteMilestoneTest: Function;
  deleteMaintest: Function;
  classes: any;
  courseName: string;
  testIndex?: number;
  courseId: any;
  testType: string;
  isExtraTests?: boolean;
  showMsg: any;
  deleteScheduleTestFromContent: Function;
  viewPlanData: any;
  setViewPlanData: Function;
  showTestVisibility?: boolean;
}

interface AddTestDialogProps {
  title: string;
  dropDownStringArray: string[];
  textFieldStringArray: { title: string; name: string; value: string }[];
  dialogButtonName: string;
  isExistingTest: boolean;
  durationAttemptRevision: { title: string; name: string; value: string; placeholder?: string }[];
  buttonName: string;
  isRequiredMapTest: boolean;
  isExistingAndScheduledTest: boolean;
  isRequiredDate: boolean;
}

interface TestComponentState {
  addTestDialogProps: AddTestDialogProps;
  courseDetails: any;
  open: boolean;
  isEdit: boolean;
  testDate: Date;
  isConflict: boolean;
  editTestFlag: boolean;
  editTestFlagStd: boolean;
  courseId: string;
  mappedTestName: string;
  testStartDate: string;
  testEndDate: string;
  newTestName: string;
  testDurationFromAPI: number;
  questionsCountFromAPI: number;
}

export class TestComponent extends PureComponent<TestComponentProps, TestComponentState> {
  zero24 = '000000000000000000000000';
  constructor(props: TestComponentProps) {
    super(props);
    this.state = {
      testDate: this.getTestDate(),
      isEdit: false,
      isConflict: this.props.isConflict || false,
      addTestDialogProps: {
        title: 'Add Test',
        dropDownStringArray: this.props.fromCombo ? ['Select goal'] : ['test'],
        textFieldStringArray: [
          { title: 'Test Name', name: 'testName', value: 'displayName' },
          {
            title: 'Test Syllabus',
            name: 'testSyllabus',
            value: 'paperDetail.syllabus.text',
          },
        ],
        dialogButtonName: 'Add Test',
        isExistingTest: true,
        durationAttemptRevision: [
          { title: 'Duration', name: 'duration', value: 'duration', placeholder: 'Enter duration' },
          {
            title: 'Max Attempt',
            name: 'maxAttempt',
            value: 'maxAttempt',
            placeholder: 'Enter max attempt',
          },
          {
            title: 'Questions Count',
            name: 'questionsCount',
            value: 'questionsCount',
            placeholder: 'Enter questions count'
          },
          {
            title: 'Block Revision Time for This Test',
            name: 'blockRevisionTime',
            value: 'blockRevisionTime',
          },
        ],
        buttonName: '+ Add Test',
        isRequiredMapTest: true,
        isExistingAndScheduledTest: true,
        isRequiredDate: true,
      },
      courseDetails: {},
      open: false,
      editTestFlag: false,
      editTestFlagStd: this.props.test,
      courseId: '',
      mappedTestName: '',
      testStartDate: '',
      testEndDate: '',
      newTestName: '',
      testDurationFromAPI: 0,
      questionsCountFromAPI: 0,
    };
    this.handleEditToggle=this.handleEditToggle.bind(this);
  }

  getTestDate = () => {
    if (this.props.test && this.props.test.hasOwnProperty('testDetails')) {
      const test = this.props.test.testDetails;
      return test.startDate || this.props.test.scheduleDate || new Date();
    } else {
      return this.props.test ? this.props.test.startDate || this.props.test.scheduleDate || new Date() : new Date();
    }
  };

  componentDidMount = () => {
    const {
      match: { params },
    } = this.props;
  };

  componentDidUpdate(prevProps: TestComponentProps) {
    if (prevProps.courseId !== this.props.courseId) {
      this.setState({
        courseId: this.props.courseId,
      });
    }
  }

  handleEditToggle = async () => {
    const { test } = this.props;
    let mappedTestName = '';
    // In addTestPopUp also hit the same with same param chck
    if (test.testId !== this.zero24){
      mappedTestName = await this.getTestDetailById(test.testId.length === 24 ? test.testId : test._id);
    }
    this.setState(
      {
        editTestFlag: !this.state.editTestFlag,
        mappedTestName: mappedTestName
      },
      () => this.handleToggleOpen()
    );
  };

  getTestDetailById = async (testId: string) => {
    try {
      
      const res = await contentService.details(`${testId}testpapers`)
      const { title, contentId, duration , content: { data : { questionsCount = 0}}} = res;
      
      
      this.setState({
        testDurationFromAPI: duration,
        questionsCountFromAPI: questionsCount
      });

      if(title && contentId) {
          return `${contentId}| ${title}`
      }
    } catch (error) {
      console.error(error)
    }
    
    return ''
  };

  handleSave = () => {
    const testStartDate = new Date(this.props.test.startDate);
    const selectedDate = new Date(this.state.testDate);
    if (testStartDate.getTime() !== selectedDate.getTime()) {
      editTest(this.props.test, this.props.phase, selectedDate, this.props.treeData, this.props.setTreeData);
      this.setState({ isEdit: false, isConflict: false });
    }
  };

  handleChange = (newDate: Date) => {
    this.setState({ testDate: newDate });
  };

  toggleEdit = () => {
    this.setState((previousState: any) => ({
      isEdit: !previousState.isEdit,
    }));
  };

  handleConflictTest = (testData: any, previousStartDate?: Date, previousEndDate?: Date) => {
    const { packageData } = this.props;
    if (Object.keys(testData).length) {
      let newTestData = JSON.parse(JSON.stringify(testData));
      const { treeData, setTreeData, testIndex, phase, } = this.props;

      const { phases = [] } = treeData;
      let clonePhases = JSON.parse(JSON.stringify(phases));
      const { startDate = null, endDate = null } = testData;
      // get index of current phase of test
      const findPhaseCurrentIndex = clonePhases.findIndex((ele: any) => ele._id === phase._id)
      // remove test from previous phase
      if (findPhaseCurrentIndex > -1 && testIndex !== undefined && testIndex > -1) {
        clonePhases[findPhaseCurrentIndex].milestoneTests.splice(testIndex, 1);
      }
      // reset conflict property
      if ((previousStartDate && new Date(startDate).getTime() !== new Date(previousStartDate).getTime())
        || (previousEndDate && new Date(endDate).getTime() !== new Date(previousEndDate).getTime())) {
        (newTestData.conflict = false);
      }
      // get new phase index
      const phaseIndex = getPhaseIndex(startDate, phases, packageData);
      // add test to new phase
      if (phaseIndex !== -1 && clonePhases[phaseIndex] && clonePhases[phaseIndex].milestoneTests) {
        clonePhases[phaseIndex].milestoneTests.push(newTestData);
      }
      else {
        // add test to last phase
        clonePhases[clonePhases.length - 1].milestoneTests.push(newTestData);
      }

      setTreeData({
        treeData: { ...treeData, phases: JSON.parse(JSON.stringify(clonePhases)) }
      })
    }
  }

  updateTestDetails(testList: any, newTestDetails: any) {
    return testList.map((testDetails: any) => {
      if (testDetails._id === newTestDetails._id) {
        testDetails = {
          ...testDetails,
          ...newTestDetails
        }
      }
      return testDetails;
    });
  }

  updateCoursePhaseWeekly(updatedTestDetails: any) {
    try {
      updatedTestDetails.testId = updatedTestDetails.testId || '000000000000000000000000';
      updatedTestDetails.scheduleID = updatedTestDetails.scheduleID || '';
      updatedTestDetails.status = updatedTestDetails.status || '';
      updatedTestDetails.duration = Number(updatedTestDetails.duration);
      updatedTestDetails.maxAttempt = Number(updatedTestDetails.maxAttempts);
      updatedTestDetails.revisionTime = Number(updatedTestDetails.revisionTime);
      updatedTestDetails.blockRevisionTime = Number(updatedTestDetails.revisionTime);
      updatedTestDetails.scheduleDate = updatedTestDetails.startDate;
      updatedTestDetails.scheduleEndDate = updatedTestDetails.endDate;
      updatedTestDetails.questionsCount = Number(updatedTestDetails.questionsCount || 0);
      updatedTestDetails.paperDetail = {
        id: updatedTestDetails.testId,
        type: updatedTestDetails.type,
        name: updatedTestDetails.name,
        syllabus: {
          text: updatedTestDetails.syllabus
        }
      };
    } catch (error) {
      console.log(error);
    }

    const coursePlan = JSON.parse(JSON.stringify(this.props.treeData));
    const phasePlan = _.get(coursePlan, 'phases', []);

    phasePlan.forEach((plan: any = []) => {
      const weeklyTest = _.get(plan, "weeks", []);
      weeklyTest.forEach((contentPlan: any) => {
        const weeklyCoursePlan = _.get(contentPlan, "content", []);
        contentPlan.content = this.updateTestDetails(weeklyCoursePlan, updatedTestDetails);
      });

      const milestoneTests = _.get(plan, "milestoneTests", []);
      plan.milestoneTests = this.updateTestDetails(milestoneTests, updatedTestDetails);

      const extraTests = _.get(plan, "extraTests", []);
      plan.extraTests = this.updateTestDetails(extraTests, updatedTestDetails);
    });

    this.props.setTreeData({ treeData: coursePlan });
  }

  handleComboSaveTest = (saveTestData: any, indexOfTest: number = 0, isEditMode: boolean = false,
    conflict: boolean = false, prevStartDate?: Date, prevEndDate?: Date
  ) => {
    if (conflict) {
      this.handleConflictTest(saveTestData, prevStartDate, prevEndDate)
    } else {
      let removeEndDate = localStorage.getItem('previousData');
      if (removeEndDate) {
        let removeDataSaveTestData = JSON.parse(JSON.stringify(localStorage.getItem('testData')));
        let newSavedData = JSON.parse(removeDataSaveTestData);
        newSavedData.testId = newSavedData.testId ? newSavedData.testId : '000000000000000000000000';
        newSavedData.contentId = newSavedData.contentId;
        newSavedData.scheduleID = newSavedData.scheduleID ? newSavedData.scheduleID : '';
        newSavedData.status = newSavedData.status ? newSavedData.status : '';
        newSavedData.duration = Number(newSavedData.duration);
        newSavedData.maxAttempt = Number(newSavedData.maxAttempts);
        newSavedData.revisionTime = Number(newSavedData.revisionTime);
        newSavedData.blockRevisionTime = Number(newSavedData.revisionTime);
        newSavedData.startDate = newSavedData.startDate;
        newSavedData.scheduleDate = newSavedData.startDate;
        newSavedData.endDate = '';
        newSavedData.scheduleEndDate = '';
        newSavedData.questionsCount = newSavedData.questionsCount ? +newSavedData.questionsCount : 0 ;
        newSavedData.paperDetail = {
          id: newSavedData.testId,
          type: newSavedData.type,
          name: newSavedData.name,
          syllabus: {
            text: newSavedData.syllabus
          }
        }
        this.handleEditTest(newSavedData);
    } else {
      let newSavedData = JSON.parse(JSON.stringify(saveTestData));
      newSavedData.testId = saveTestData.testId ? saveTestData.testId : '000000000000000000000000';
      newSavedData.contentId = saveTestData.contentId;
      newSavedData.scheduleID = saveTestData.scheduleID ? saveTestData.scheduleID : '';
      newSavedData.status = saveTestData.status ? saveTestData.status : '';
      newSavedData.duration = Number(saveTestData.duration);
      newSavedData.maxAttempt = Number(saveTestData.maxAttempts);
      newSavedData.revisionTime = Number(saveTestData.revisionTime);
      newSavedData.blockRevisionTime = Number(saveTestData.revisionTime);
      newSavedData.startDate = saveTestData.startDate;
      newSavedData.scheduleDate = saveTestData.startDate;
      newSavedData.endDate = saveTestData.endDate;
      newSavedData.scheduleEndDate = saveTestData.endDate;
      newSavedData.questionsCount = saveTestData.questionsCount ? +saveTestData.questionsCount : 0 ;
      newSavedData.paperDetail = {
        id: newSavedData.testId,
        type: saveTestData.type,
        name: saveTestData.name,
        syllabus: {
          text: saveTestData.syllabus
        }
      };
      this.handleEditTest(newSavedData);
      localStorage.removeItem('testData')
    }
      
    this.updateCoursePhaseWeekly(saveTestData);
      
      // const { phase, treeData, setTreeData, testType } = this.props;
      
      // const { phases = [] } = treeData;
      // const indexOfPhase = phases.findIndex((ele: any) => ele._id === phase._id);
      // let clonePhases = JSON.parse(JSON.stringify(phases));
      
      // if (isEditMode) {
      //   if(clonePhases[indexOfPhase]) {
      //     clonePhases[indexOfPhase].milestoneTests[indexOfTest] = newSavedData;
      //   }
      // } else {
      //   clonePhases[indexOfPhase].milestoneTests.push(newSavedData);
      // }

      // let newUpdatedTreeData = { ...treeData, phases: JSON.parse(JSON.stringify(clonePhases)) };
      // setTreeData({
      //   treeData: newUpdatedTreeData,
      // });
    }
    this.setState({
      editTestFlag: false,
      open: false,
    });
  };

  handleEditForCombo = async () => {

    const { test } = this.props;
    localStorage.setItem('testData', JSON.stringify(test))
    let mappedTestName = '';
    
    if (test.testId !== this.zero24){
      mappedTestName = await this.getTestDetailById(test.testId.length === 24 ? test.testId : test._id);
    }
    
    this.setState(
      {
        editTestFlag: true,
        mappedTestName: mappedTestName
      },
      () => this.handleEditAndClose()
    );
  };
  
  handleEditAndClose = () => {
    this.setState((previousState: any) => ({
      open: !previousState.open,
    }));
  };

  changeTestVisibilityToggle = (contentItem: any, toggleValue: any) => {
    const { treeData, setTreeData, phase: conceptPhaseData, isExtraTests } = this.props;
    const { phases = [] } = treeData || {};
    let cloneTree = JSON.parse(JSON.stringify(treeData));
    let clonePhases = JSON.parse(JSON.stringify(phases));
    const { weekIndex, phaseIndex } = conceptPhaseData;
    const content = weekIndex !== undefined ? clonePhases[phaseIndex]['weeks'][weekIndex]['content']
    :
    isExtraTests ? clonePhases[phaseIndex]['extraTests'] : clonePhases[phaseIndex]['milestoneTests'];
    for(let i=0;i<content.length;i++){
        if (content[i]['testId'] === contentItem['testId']) {
          content[i].isHidden = toggleValue;
        }
    }
    cloneTree = { ...cloneTree, phases: JSON.parse(JSON.stringify(clonePhases)) }
    setTreeData && setTreeData({
        treeData: cloneTree
    });
  };

  testDetails = () => {
    const { test, classes, testType, showTestVisibility } = this.props;
    const { testStartDate, testEndDate } = this.state;
    let newStartTime = dateService.timeDate(new Date(testStartDate))
    let newEndTime = dateService.timeDate(new Date(testEndDate))
    const { newTestName } = this.state;
    if (test) {
      let testTime = '', testEndTime = '', endDate;
      if (this.state.testDate) {
        const date = this.props.test.startDate ? new Date(this.props.test.startDate.toString()) : '';
        endDate = test.endDate ? new Date(test.endDate.toString()) : '';
        testTime = dateService.timeDate(date);
        endDate && (testEndTime = dateService.timeDate(endDate));
      }
      return (
        <Grid container alignItems='center'>
          {testType === 'week' ?
            <Grid className={classes.displayFlex}>
              <span>
                <img src='/assets/svg/test-icon.svg' alt='target-icon' />
              </span>
            </Grid>
            :
            <Grid className={classes.displayFlex}>
              <span>
                <img src='/assets/svg/goalGreyNav.svg' alt='target-icon' />
              </span>
            </Grid>
          }

          <Grid style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography className={classes.marginL10} style={{ display: 'flex', alignItems: 'center' }}>
              <span className={classes.testTitle}>{test.testDetails && Object.keys(test.testDetails).length ? (newTestName) : (test.name || test.displayName)}</span>
              <span style={bullets}>&bull;</span>
              <span style={dateStyle}>{`${testTime} ${ test.endDate && test.endDate.toString() !== 'Invalid Date' ? `- ${testEndTime}` : ''}`}</span>
            </Typography>
            <Typography className={classes.marginL13}>
              {test.syllabus ? <span style={{ display: 'flex', maxWidth: '900px' }} dangerouslySetInnerHTML={{ __html: test.syllabus.replace(/(<\/?(?:mark)[^>]*>)|<[^>]+>/ig, "$1") }}>
              </span> : <></>}
            </Typography>
          </Grid>

          <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
            {showTestVisibility && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "15px",
                }}
              >
                Hide Test <CustomInfoIcon
                  infoDialogContentType="Hide Test"
                  isCenterArrow={true}
                  isRightArrow={false}
                  isInfoIcon={true}
                  knowMoreAbout={false}
                  dialogTitle="Hide Test"
                  dialogPara={HIDE_TEST_POPUP_INFO}
                  details="Click to know more"
                  toolTipDirection="top"
                />
                <ToggleInput
                  isChecked={test.isHidden}
                  handleToggle={(event: any) => this.changeTestVisibilityToggle(test,event)}
                />
              </div>
            )}
            <span
              style={{
                fontSize: '14px',
                color: '#1d7dea',
                fontWeight: 700,
                textDecoration: 'none',
                cursor: 'pointer',
                marginRight: '12px',
              }}
              onClick={!this.props.fromCombo ? this.handleEditToggle : this.handleEditForCombo}
            >
              <img src='/assets/svg/editOutline.svg' alt='edit-icon' />
            </span>
            <span
              style={{
                fontSize: '14px',
                color: '#1d7dea',
                fontWeight: 700,
                textDecoration: 'none',
                cursor: 'pointer',
                marginLeft: 'auto',
              }}
              // onClick={!this.props.fromCombo ? this.handleDeleteTest : this.handleDeleteTestFromComboCourse}
              onClick={this.handleDeleteTest}
            >
              <img src='/assets/svg/delete.svg' alt='delete-icon' />
            </span>
          </div>
        </Grid>
      );
    } else {
      return <></>;
    }
  };

  optionToAddTests = () => {
    const { classes } = this.props;
    const { phaseIndex, name } = this.props.phase;
    return (
      <>
        <Grid container alignItems='center' justify='space-between'>
          <Grid className={classes.displayFlex}>
            <span>
              <img src='/assets/svg/goalGreyNav.svg' alt='target-icon' className={classes.faded} />
            </span>
            <Grid>
              <Typography className={classes.testTitle}>{`Test-${phaseIndex + 1}`}</Typography>
              <Typography style={{ color: '#666' }}>{`Add test for entire milestone - ${name}`}</Typography>
            </Grid>
          </Grid>
          <div>
            <span style={{ color: 'red' }}>Add atleast one milestone test to complete course plan</span>
          </div>
          <Button
            style={{
              fontSize: '14px',
              color: '#1d7dea',
              fontWeight: 700,
              textDecoration: 'none',
            }}
            onClick={this.handleToggleOpen}
          >
            +ADD TEST
          </Button>
        </Grid>
      </>
    );
  };

  handleToggleOpen = () => {
    this.setState((previousState: any) => ({
      open: !previousState.open,
      editTestFlag: false,
    }));
  };

  handleEditTest = (testData: any) => {
    const { packageData } = this.props;
    const { phase, testIndex, isExtraTests = false, treeData: { phases = []} } = this.props;
    const courseId = testData.courseId;
    const testType = this.checkTestType();
    
    switch (testType) {
      case 'Phase':
        if(isExtraTests) {
          this.props.updateMainTest({ testData, phase, isDelete: false, courseId: courseId, testIndex: testIndex });
        } else {
          testData.type = testData.type === "full" ? "phase" : testData.type;
          this.props.updateMilestoneTest({ testData, phase, isDelete: false, courseId: courseId, testIndex: testIndex });
        }
        
        break;
      case 'Week':
        this.props.updateMainTest({ testData, phase, isDelete: false, courseId: courseId, testIndex: testIndex });
        break;
      default:
    }
    // Update testDate to reflect updated date in the card
    const newScheduleDate = _.get(testData, 'scheduleDate', '');
    const newScheduleEndDate = _.get(testData, 'scheduleEndDate', '')
    if (newScheduleDate) {
      this.handleChange(newScheduleDate);
    }

    this.setState({
      testStartDate: testData.scheduleDate,
      testEndDate: testData.scheduleEndDate,
      newTestName: testData.displayName
    })
  };

  handleDeleteTestFromComboCourse = () => {
    const { phase, treeData, setTreeData, testIndex } = this.props;
    const { phases = [] } = treeData;
    const indexOfPhase = phases.findIndex((ele: any) => ele._id === phase._id);
    let clonePhases = JSON.parse(JSON.stringify(phases));
    clonePhases[indexOfPhase].milestoneTests = clonePhases[indexOfPhase].milestoneTests.filter(
      (ele: any, indexOfTest: number) => indexOfTest !== testIndex
    );
    let newUpdatedTreeData = { ...treeData, phases: JSON.parse(JSON.stringify(clonePhases)) };
    setTreeData({
      treeData: newUpdatedTreeData,
    });
  };

  handleDeleteTest = () => {
    const { phase, test, testIndex, isExtraTests = false } = this.props;
    const courseId = _.get(this.props.match, 'params.id', '');
    const testType = this.checkTestType();
    switch (testType) {
      case 'Phase':
        if(isExtraTests){
          this.props.deleteMaintest({
            testData: test,
            phase,
            isDelete: true,
            courseId,
            testIndex
          });
        } else {
          if (phase.milestoneTests && phase.milestoneTests.length) {
            this.props.deleteMilestoneTest({
              testData: test,
              phase,
              isDelete: true,
              courseId,
              testIndex
            });
          } else if (phase.content && phase.content.length) {
            this.props.deleteScheduleTestFromContent({
              testData: test,
              phase,
              isDelete: true,
              courseId,
              testIndex
            });
          }
        }
        break;
      case 'Week':
        this.props.deleteMaintest({
          testData: test,
          phase,
          isDelete: true,
          courseId,
          testIndex
        });
        break;
      default:
    }
  };

  checkTestType = () => {
    const { phase } = this.props;
    
    let testType = '';
    if (phase.key === 'phase') {
      testType = 'Phase';
    } else {
      testType = 'Week';
    }
    return testType;
  };

  render() {
    const { addTestDialogProps, open, editTestFlag, editTestFlagStd , mappedTestName, testDurationFromAPI, questionsCountFromAPI} = this.state;
    const { packageData, phase, phaseIndex, treeData, testType, isExtraTests } = this.props;
    
    return (
      <div
        style={{
          borderBottom: '1px solid lightgrey',
          padding: `1.2% 4%`,
          backgroundColor: this.state.isConflict ? '#FFF4F4' : 'white',
          borderLeft: this.state.isConflict ? '10px solid #f4290d' : '',
        }}
      >
        <div>{this.props.isEmpty ? this.optionToAddTests() : this.testDetails()}</div>
        <span>
          {this.props.fromCombo ? (
            <ComboAndStandardTest
              test={this.props.test}
              packageData={this.props.packageData}
              match={this.props.match}
              isEmpty={this.props.isEmpty}
              isConflict={this.props.isConflict}
              phase={this.props.phase}
              fromCombo={this.props.fromCombo}
              open={this.state.open}
              handleToggleOpen={this.handleToggleOpen}
              handleComboSaveTest={this.handleComboSaveTest}
              editMode={editTestFlag}
              editTestDetails={this.props.test}
              coursePlanId={this.props.treeData._id}
              testIndex={this.props.testIndex}
              handleDeleteTestFromComboCourse={this.handleDeleteTestFromComboCourse}
              mappedTest={mappedTestName}
              courseId={packageData && packageData.courseDetails[0].courseId}
              testType={testType}
              testDurationFromAPI={testDurationFromAPI}
              questionsCountFromAPI={questionsCountFromAPI}
              phaseIndex={phaseIndex}
              packageEndDate={packageData.expiryDate}
              isExtraTests={isExtraTests}
            />
          ) : open ? (
            <AddTestDialogPopUp
              title={editTestFlagStd ? 'Edit Test' : addTestDialogProps.title}
              dropDownStringArray={addTestDialogProps.dropDownStringArray}
              textFieldStringArray={addTestDialogProps.textFieldStringArray}
              dialogButtonName={editTestFlagStd ? 'Update Test' : addTestDialogProps.dialogButtonName}
              isExistingTest={!editTestFlagStd} // Check
              durationAttemptRevision={addTestDialogProps.durationAttemptRevision}
              buttonName={'Edit Test'}
              isRequiredMapTest={addTestDialogProps.isRequiredMapTest}
              isExistingAndScheduledTest={!editTestFlagStd} // Check
              isRequiredDate={addTestDialogProps.isRequiredDate}
              courseId={packageData && packageData.courseDetails[0].courseId}
              courseDetails={this.state.courseDetails}
              handleAddTest={this.handleEditTest}
              test={this.props.test}
              editMode={editTestFlagStd}
              open={open}
              onClose={this.handleToggleOpen}
              handleToggleOpen={this.handleToggleOpen}
              courseName={packageData.courseDetails[0].courseType.name}
              phases={treeData && treeData.phases || {}}
              phase={phase}
              phaseIndex={phaseIndex}
              packageStartDate={packageData.startDate}
              packageEndDate={packageData.expiryDate}
              mappedTest={mappedTestName}
              testType={testType}
              isExtraTests={isExtraTests}
              testDurationFromAPI={testDurationFromAPI}
              questionsCountFromAPI={questionsCountFromAPI}
            />
          ) : (
                <></>
              )}
        </span>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    packageData: _.get(state, 'courseMangementData.contentManagementData.packageByIdData.packageData', {}),
    treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
  };
};

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setTreeData: contentManagementAction.setTreeData,
      updateMilestoneTest: contentManagementAction.updateMilestoneTest,
      updateMainTest: contentManagementAction.updateMainTest,
      deleteMilestoneTest: contentManagementAction.deleteMilestoneTest,
      deleteMaintest: contentManagementAction.deleteMaintest,
      deleteScheduleTestFromContent: contentManagementAction.deleteScheduleTestFromContent,
      showMsg
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(withRouter(TestComponent)));
